<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Invoices"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    :name="gridName"
    :headerTitle="titles[kind]"
    :items="getItems"
    :headerShowReloadButton="b_2248226175642056_headerShowReloadButton"
    checkbox-row-selection
    footer-totals
    export-to-csv
    :exportToCsvFilename="'invoices'|pgettext('ExportFilename')"
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    v-if="loaded"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <ItpBox
      alignItems="center"
      slot="toolbar"
    >
      <InvoicesFilters
        :kind="kind"
        @submit="evh_6466705138206980_submit($event, {})"
      >
      </InvoicesFilters>
      <vr>
      </vr>
      <b-dropdown
        :text="'Commands'|gettext"
        variant="light"
        class="border rounded"
      >
        <ItpButton
          icon="fa-plus"
          :text="'New Invoice...'|pgettext('Invoices')"
          dropdown-item
          @click="evh_8697745105058001_click($event, {})"
        >
        </ItpButton>
        <ItpButton
          :text="'Import Invoices...'|pgettext('Invoices')"
          :icon="$config.uploadIcon"
          dropdown-item
          v-if="kind === 'incoming'"
          @click.prevent="evh_5382094220310827_clickPrevent($event, {})"
        >
        </ItpButton>
        <ItpButton
          :text="'Set VAT period...'|pgettext('Invoices')"
          :icon="$config.vatPeriod.icon"
          :disabled="!selectedItems || !selectedItems.length"
          dropdown-item
          v-if="kind === 'incoming'"
          @click.prevent="evh_2688566256707306_clickPrevent($event, {})"
        >
        </ItpButton>
        <ArtifactJob
          icon="ic:baseline-download"
          :text="'Download views'|gettext"
          :disabled="!selectedItems || !selectedItems.length"
          operation="download_invoice_views"
          :payload="() => ({ identities: selectedItems.map(p => p.id)})"
          dropdown-item
        >
        </ArtifactJob>
      </b-dropdown>
      <JobHandlerControl
        jobType="invoice_print"
        load-current
        :text="'Print invoices...'|pgettext('Invoices')"
        icon="icon-park-outline:printer-one"
        :payload="onPrintInvoicesPayload"
        :disabled="!selectedItems || !selectedItems.length"
        class="ml-2"
      >
      </JobHandlerControl>
    </ItpBox>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "invoices",
    path: "/invoices",
    component: "Invoices",
    params: [{
      name: "kind",
      prop: "kind",
    }
      ,
    ]

  }
)

addRoute(
  {
    name: "invoicesIn",
    path: "/invoices-in",
    component: "Invoices",
    componentProps: [{
      name: "kind",
      value: "incoming",
    }
      ,
    ]

  }
)

addRoute(
  {
    name: "invoicesOut",
    path: "/invoices-out",
    component: "Invoices",
    componentProps: [{
      name: "kind",
      value: "outgoing",
    }
      ,
    ]

  }
)

@Component()
export default class Invoices extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getItems(...args: any[]) {
    const parameters = this.params;
    return parameters ? this.$fn.fetch('list_invoice', { parameters }) : []
  }

  invoiceTypeBadgeClass(...args: any[]) {
    const [row] = args;
    const cc = this.$config.invoice.types.colorCodes[row.invoice_type];
    return `bg-${cc.bg} text-${cc.text}`
  }

  onPrintInvoicesPayload(...args: any[]) {
    return this.$imodal
      .show({ name: 'PrintInvoices' })
      .then(result => {
        if (!result || result.cancel || !result.value) {
          return;
        }
        return this.selectedItems.map(p => ({
          invoice_id: p.id,
          copies: result.copies,
          printer: result.printer ? result.printer.id : null,
        }))
      }
      )
  }

  @Prop({
    required: true,
    type: String,
  })
  kind!: string;

  @Watch('kind')
  onKind(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("kind")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  titles!: any;
  selectedItems!: any;
  params!: any;
  gridName!: any;

  async $$load_gridName() {
    return 'invoices.' + this.kind
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_headerShowReloadButton!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;

  async $$load_b_2248226175642056_columns() {
    return [{
      field: "company",
      name: this.$fn.pgettext("Invoices", "Company"),
      formatter: {
        name: "chain",
        mode: "mapReduce",
        formatterContext: "item",
        formatters: [{
          name: "getvalue",
          opts: {
            field: "name",
            source: "value",
          }
          ,
        }
          ,
        {
          name: "routeLink",
          to: "company",
          navigateOnIconClick: true,
          params: {
            id: "id",
          }
          ,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "invoice_number",
      name: this.$fn.pgettext("Invoices", "Invoice nr"),
      type: "command",
      formatter: [{
        name: "chain",
        formatters: [{
          name: "template",
          engine: "hb",
          format: "#!{{ $value }} {{~#if reference_number }} ({{ reference_number }}){{~/if }}",
        }
          ,
        {
          name: "routeLink",
          to: "invoice",
          params: {
            id: "id",
          }
          ,
        }
          ,
        {
          name: "cellclass",
          value: (row) => ({
            'font-weight-bold': true,
            'bg-yellow-200': !row.locked,
            'bg-yellow-500 text-yellow-800': row.is_corrected,
            'bg-red-300 text-red-800': row.is_reversed,
          }),
        }
          ,
        ]
        ,
      }
        ,
      ]
      ,
    }
      ,
    {
      field: "data_reporting_status",
      name: this.$fn.pgettext("Invoices", "NAV"),
      type: "command",
      formatter: {
        name: "template",
        engine: "hb",
        format: "<span>\n\
  {{~#if $value }}\n\
    {{~#if (eq $value.status \"done\") }}\n\
      <iconify-icon icon=\"fluent:cloud-sync-complete-16-regular\" class=\"text-green-500\">\n\
      </iconify-icon>\n\
    {{~else }}\n\
      {{~#if $value.status }}\n\
        <iconify-icon icon=\"fluent:warning-12-filled\" class=\"text-yellow-500\" title=\"{{ $value.status }}\">\n\
        </iconify-icon>\n\
      {{~/if }}\n\
    {{~/if }}\n\
\n\
    {{~#if $value.message }}\n\
      <iconify-icon icon=\"fluent:warning-12-filled\" class=\"text-yellow-500\" title=\"{{ $value.message }}\">\n\
      </iconify-icon>\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
      }
      ,
    }
      ,
    {
      field: "invoice_type",
      name: this.$fn.pgettext("Invoices", "Type"),
      formatter: {
        name: "chain",
        formatters: [{
          name: "gettext",
          context: "InvoiceType",
          conversion: "StartCase",
          filterInput: true,
        }
          ,
        {
          name: "badge",
          dot: true,
          pill: true,
          badgeClass: this.invoiceTypeBadgeClass,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "invoice_status",
      name: this.$fn.pgettext("Invoices", "Status"),
      formatter: {
        name: "chain",
        formatters: [{
          name: "gettext",
          context: "Status",
          conversion: "StartCase",
          filterInput: true,
        }
          ,
        {
          name: "badge",
          variantmap: this.$config.invoice.invoiceStatusVariants,
          variantMapSource: "fieldValue",
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "printout",
      name: this.$fn.pgettext("Invoices", "Printout"),
      type: "command",
      formatter: {
        name: "attachment",
      }
      ,
    }
      ,
    {
      field: "attachments",
      name: this.$fn.pgettext("Invoices", "Attachments"),
      type: "command",
      formatter: {
        name: "attachment",
      }
      ,
    }
      ,
    {
      field: "register_entry",
      name: this.$fn.pgettext("Invoices", "Register entry"),
      type: "command",
      params: {
        sortPath: "register_entry.entry_number",
      }
      ,
      formatter: {
        name: "chain",
        mode: "mapReduce",
        separator: ", ",
        formatterContext: "item",
        formatters: [{
          name: "getvalue",
          opts: {
            field: "entry_number",
            source: "value",
          }
          ,
        }
          ,
        {
          name: "link",
          href: "#",
        }
          ,
        {
          name: "cellclass",
          value: (value) => ({
            'font-weight-bold': true,
            'bg-yellow-200': value && !value.locked
          }),
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "vat_period",
      name: this.$fn.pgettext("Invoices", "VAT period"),
      type: "command",
      formatter: [{
        name: "chain",
        formatters: [{
          name: "template",
          engine: "hb",
          format: "#!{{ $value.name }}",
        }
          ,
        ]
        ,
      }
        ,
      ]
      ,
    }
      ,
    {
      field: "invoice_date",
      name: this.$fn.pgettext("Invoices", "Date"),
    }
      ,
    {
      field: "fulfillment_date",
      name: this.$fn.pgettext("Invoices", "Fulfillment date"),
      type: "date",
    }
      ,
    {
      field: "due_date",
      name: this.$fn.pgettext("Invoices", "Due date"),
      type: "date",
    }
      ,
    {
      field: "client_name",
      name: this.$fn.pgettext("Invoices", "Client"),
      formatter: {
        name: "routeLink",
        to: "company",
        navigateOnIconClick: true,
        params: {
          id: "client_id",
        }
        ,
      }
      ,
    }
      ,
    {
      field: "description",
      name: this.$fn.pgettext("Invoices", "Description"),
    }
      ,
    {
      field: "net_amount",
      name: this.$fn.pgettext("Invoices", "Net"),
      type: "number",
      formatter: "number",
    }
      ,
    {
      field: "vat_amount",
      name: this.$fn.pgettext("Invoices", "VAT"),
      type: "number",
      formatter: "number",
    }
      ,
    {
      field: "total_amount",
      name: this.$fn.pgettext("Invoices", "Total"),
      type: "number",
      formatter: "number",
    }
      ,
    {
      field: "outstanding_amounts",
      name: this.$fn.pgettext("Invoices", "Outstanding Amounts"),
      type: "number",
      formatter: {
        name: "chain",
        formatters: [{
          name: "number",
        }
          ,
        {
          name: "cellclass",
          value: (row) => {
            if (row.flags && row.flags.no_payment_required) {
              return 'font-weight-bold text-decoration-line-through';
            }

            if (row.outstanding_amounts != null && row.outstanding_amounts > 0) {
              return 'font-weight-bold text-red-500';
            }

            if (row.outstanding_amounts != null && row.outstanding_amounts < 0) {
              return 'font-weight-bold text-blue-500';
            }

            if (row.outstanding_amounts == 0) {
              return 'font-weight-bold text-green-500';
            }
          },
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "paid_amount",
      name: this.$fn.pgettext("Invoices", "Paid"),
      type: "number",
      formatter: {
        name: "chain",
        formatters: [{
          name: "number",
        }
          ,
        {
          name: "cellclass",
          value: (row) => {
            if (row.flags && row.flags.no_payment_required) {
              return 'font-weight-bold text-decoration-line-through';
            }
          },
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "max_payment_date",
      name: this.$fn.pgettext("PaymentBrowserView", "Date of last settlement"),
      type: "date",
    }
      ,
    {
      field: "currency",
      name: this.$fn.pgettext("Invoices", "Currency"),
    }
      ,
    {
      field: "vat_deductible",
      if: this.kind === 'incoming',
      name: this.$fn.pgettext("InvoicesView", "VAT deductible"),
      type: "number",
      formatter: "number",
    }
      ,
    {
      field: "tags",
      name: this.$fn.pgettext("Invoices", "Tags"),
    }
      ,
    {
      field: "rentals",
      name: this.$fn.pgettext("Invoices", "Rentals"),
      params: {
        sortPath: "rentals.0.name",
      }
      ,
      formatter: {
        name: "chain",
        mode: "mapReduce",
        separator: ", ",
        formatterContext: "value",
        formatters: [{
          name: "getvalue",
          opts: {
            field: "name",
            source: "value",
          }
          ,
        }
          ,
        {
          name: "routeLink",
          to: "rental",
          navigateOnIconClick: true,
          params: {
            id: "id",
          }
          ,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "contracts",
      name: this.$fn.pgettext("Invoices", "Contracts"),
      formatter: {
        name: "chain",
        mode: "mapReduce",
        separator: ", ",
        formatterContext: "value",
        formatters: [{
          name: "getvalue",
          opts: {
            field: "contract_number",
            source: "value",
          }
          ,
        }
          ,
        {
          name: "routeLink",
          to: "contract",
          navigateOnIconClick: true,
          params: {
            id: "id",
          }
          ,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "created_at",
      name: this.$fn.pgettext("BrowserColumn", "Create time"),
      formatter: "datetime",
    }
      ,
    ]
  }

  dataMembers = ['titles', 'selectedItems', 'params', 'gridName', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_headerShowReloadButton', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        titles: {
          incoming: this.$fn.pgettext("Invoices", "Vendor invoices"),
          outgoing: this.$fn.pgettext("Invoices", "Customer invoices"),
        }
        ,
        selectedItems: [
        ]
        ,
        params: null,
        gridName: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_headerShowReloadButton: false,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_2248226175642056_columns: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.titles[this.kind],
        icon: this.$config.invoice.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3272_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3272, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_3274_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_3274, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_script_3278_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2248226175642056_script_3278, alias=undefined
    this.$refs.grid.reload()
  }

  async act_2248226175642056_script_3278_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2248226175642056_script_3278, alias=undefined
    return {
      value: () => this.act_2248226175642056_script_3278_getActionArgs_value($event),
    }
  }

  async act_2248226175642056_showModal_3276_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_3276, alias=undefined
    return {
      name: "RegisterEntry",
      props: {
        oid: $event.data.data.register_entry.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_3275_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_3275, alias=undefined
    return $event.data.column.id === 'register_entry' && $event.data.data.register_entry != null
  }

  async act_2248226175642056_script_3280_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2248226175642056_script_3280, alias=undefined
    this.$app.attachments.downloadAttachmentFromSlickCommand($event)
  }

  async act_2248226175642056_script_3280_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2248226175642056_script_3280, alias=undefined
    return {
      value: () => this.act_2248226175642056_script_3280_getActionArgs_value($event),
    }
  }

  async evh_2248226175642056_command_3279_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_3279, alias=undefined
    return $event.data.column.id === 'attachments'
  }

  async act_2248226175642056_script_3282_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2248226175642056_script_3282, alias=undefined
    this.$app.attachments.downloadInvoiceView($event.data.data.id, $event.data.data.invoice_number)
  }

  async act_2248226175642056_script_3282_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2248226175642056_script_3282, alias=undefined
    return {
      value: () => this.act_2248226175642056_script_3282_getActionArgs_value($event),
    }
  }

  async evh_2248226175642056_command_3281_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_3281, alias=undefined
    return $event.data.column.id === 'printout'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_setData_3284_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_6466705138206980_setData_3284, alias=undefined
    return {
      path: "params",
      value: { ...$event.data, kind: this.kind },
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_6466705138206980_script_3286_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6466705138206980_script_3286, alias=undefined
    this.$refs.grid.reload()
  }

  async act_6466705138206980_script_3286_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6466705138206980_script_3286, alias=undefined
    return {
      value: () => this.act_6466705138206980_script_3286_getActionArgs_value($event),
    }
  }

  async evh_6466705138206980_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_submit.executeFromDOM(this, event, scope);
  }

  async act_8697745105058001_showModal_3288_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8697745105058001_showModal_3288, alias=undefined
    return {
      name: "CreateInvoice",
      props: {
        invoiceKind: this.kind,
      }
      ,
    }
  }

  async evh_8697745105058001_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8697745105058001_click.executeFromDOM(this, event, scope);
  }

  async act_5382094220310827_showModal_3290_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5382094220310827_showModal_3290, alias=undefined
    return {
      name: "ImportInvoices",
    }
  }

  async evh_5382094220310827_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5382094220310827_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_2688566256707306_reloadSlickgrid_3294_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2688566256707306_reloadSlickgrid_3294, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_2688566256707306_close_3293_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2688566256707306_close_3293, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_2688566256707306_showModal_3292_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2688566256707306_showModal_3292, alias=undefined
    return {
      name: "SetInvoiceVatPeriod",
      props: {
        invoices: this.selectedItems,
      }
      ,
    }
  }

  async evh_2688566256707306_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2688566256707306_clickPrevent.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3272: actions.CloseModalAction;
    evh_7315092382398562_close_3271: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_3274: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_3273: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_script_3278: actions.ScriptAction;
    evh_2248226175642056_saved_3277: actions.EventHandlerImpl;
    act_2248226175642056_showModal_3276: actions.ShowModalAction;
    evh_2248226175642056_command_3275: actions.EventHandlerImpl;
    act_2248226175642056_script_3280: actions.ScriptAction;
    evh_2248226175642056_command_3279: actions.EventHandlerImpl;
    act_2248226175642056_script_3282: actions.ScriptAction;
    evh_2248226175642056_command_3281: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_6466705138206980_setData_3284: actions.SetDataAction;
    evh_6466705138206980_submit_3283: actions.EventHandlerImpl;
    act_6466705138206980_script_3286: actions.ScriptAction;
    evh_6466705138206980_submit_3285: actions.EventHandlerImpl;
    evh_6466705138206980_submit: actions.EventHandlerGroup;
    act_8697745105058001_showModal_3288: actions.ShowModalAction;
    evh_8697745105058001_click_3287: actions.EventHandlerImpl;
    evh_8697745105058001_click: actions.EventHandlerGroup;
    act_5382094220310827_showModal_3290: actions.ShowModalAction;
    evh_5382094220310827_clickPrevent_3289: actions.EventHandlerImpl;
    evh_5382094220310827_clickPrevent: actions.EventHandlerGroup;
    act_2688566256707306_reloadSlickgrid_3294: actions.ReloadSlickgridAction;
    evh_2688566256707306_close_3293: actions.EventHandlerImpl;
    act_2688566256707306_showModal_3292: actions.ShowModalAction;
    evh_2688566256707306_clickPrevent_3291: actions.EventHandlerImpl;
    evh_2688566256707306_clickPrevent: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3272 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3272_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3271 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3272,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3271],
      }
    );
    const act_2248226175642056_setData_3274 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_3274_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_3273 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_3274,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_3273],
      }
    );
    const act_2248226175642056_script_3278 = new actions.ScriptAction(
      {
        actionArgs: this.act_2248226175642056_script_3278_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_saved_3277 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_script_3278,
        event: "saved",
        displayName: "script",
      }
    );
    const act_2248226175642056_showModal_3276 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_3276_getActionArgs,
        events: [evh_2248226175642056_saved_3277],
      }
    );
    const evh_2248226175642056_command_3275 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_3276,
        event: "command",
        when: this.evh_2248226175642056_command_3275_getWhen,
        displayName: "showModal",
      }
    );
    const act_2248226175642056_script_3280 = new actions.ScriptAction(
      {
        actionArgs: this.act_2248226175642056_script_3280_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_3279 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_script_3280,
        event: "command",
        when: this.evh_2248226175642056_command_3279_getWhen,
        displayName: "script",
      }
    );
    const act_2248226175642056_script_3282 = new actions.ScriptAction(
      {
        actionArgs: this.act_2248226175642056_script_3282_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_3281 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_script_3282,
        event: "command",
        when: this.evh_2248226175642056_command_3281_getWhen,
        displayName: "script",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_3275, evh_2248226175642056_command_3279, evh_2248226175642056_command_3281],
      }
    );
    const act_6466705138206980_setData_3284 = new actions.SetDataAction(
      {
        actionArgs: this.act_6466705138206980_setData_3284_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_submit_3283 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_setData_3284,
        event: "submit",
        displayName: "setData",
      }
    );
    const act_6466705138206980_script_3286 = new actions.ScriptAction(
      {
        actionArgs: this.act_6466705138206980_script_3286_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_submit_3285 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_script_3286,
        event: "submit",
        displayName: "script",
      }
    );
    const evh_6466705138206980_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_submit_3283, evh_6466705138206980_submit_3285],
      }
    );
    const act_8697745105058001_showModal_3288 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8697745105058001_showModal_3288_getActionArgs,
        events: [],
      }
    );
    const evh_8697745105058001_click_3287 = new actions.EventHandlerImpl(
      {
        action: act_8697745105058001_showModal_3288,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_8697745105058001_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8697745105058001_click_3287],
      }
    );
    const act_5382094220310827_showModal_3290 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5382094220310827_showModal_3290_getActionArgs,
        events: [],
      }
    );
    const evh_5382094220310827_clickPrevent_3289 = new actions.EventHandlerImpl(
      {
        action: act_5382094220310827_showModal_3290,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_5382094220310827_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5382094220310827_clickPrevent_3289],
      }
    );
    const act_2688566256707306_reloadSlickgrid_3294 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2688566256707306_reloadSlickgrid_3294_getActionArgs,
        events: [],
      }
    );
    const evh_2688566256707306_close_3293 = new actions.EventHandlerImpl(
      {
        action: act_2688566256707306_reloadSlickgrid_3294,
        event: "close",
        when: this.evh_2688566256707306_close_3293_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_2688566256707306_showModal_3292 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2688566256707306_showModal_3292_getActionArgs,
        events: [evh_2688566256707306_close_3293],
      }
    );
    const evh_2688566256707306_clickPrevent_3291 = new actions.EventHandlerImpl(
      {
        action: act_2688566256707306_showModal_3292,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_2688566256707306_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_2688566256707306_clickPrevent_3291],
      }
    );
    return {
      act_7315092382398562_closeModal_3272,
      evh_7315092382398562_close_3271,
      evh_7315092382398562_close,
      act_2248226175642056_setData_3274,
      evh_2248226175642056_selectedRowsChanged_3273,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_script_3278,
      evh_2248226175642056_saved_3277,
      act_2248226175642056_showModal_3276,
      evh_2248226175642056_command_3275,
      act_2248226175642056_script_3280,
      evh_2248226175642056_command_3279,
      act_2248226175642056_script_3282,
      evh_2248226175642056_command_3281,
      evh_2248226175642056_command,
      act_6466705138206980_setData_3284,
      evh_6466705138206980_submit_3283,
      act_6466705138206980_script_3286,
      evh_6466705138206980_submit_3285,
      evh_6466705138206980_submit,
      act_8697745105058001_showModal_3288,
      evh_8697745105058001_click_3287,
      evh_8697745105058001_click,
      act_5382094220310827_showModal_3290,
      evh_5382094220310827_clickPrevent_3289,
      evh_5382094220310827_clickPrevent,
      act_2688566256707306_reloadSlickgrid_3294,
      evh_2688566256707306_close_3293,
      act_2688566256707306_showModal_3292,
      evh_2688566256707306_clickPrevent_3291,
      evh_2688566256707306_clickPrevent,
    }
  }
}

Vue.component("Invoices", Invoices);

</script>